import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHistory } from '@fortawesome/pro-duotone-svg-icons/faHistory'
import ContentDossierLog from '@/feature/ContentDossier/Toolbar/Components/ContentDossierLog'
import {
    ContentDossierHistoryProps,
    ContentDossierHistoryState,
} from '../types'
import { ToolbarButton } from '@/Components/Elements/StyledComponents/Buttons'

class ContentDossierHistory extends React.Component<
    ContentDossierHistoryProps,
    ContentDossierHistoryState
> {
    constructor(props: ContentDossierHistoryProps) {
        super(props)

        this.state = {
            showForm: false,
        }
    }

    render() {
        return (
            <>
                {this.state.showForm ? (
                    <ContentDossierLog
                        dossier={this.props.dossier}
                        onClose={() => this.setState({ showForm: false })}
                        kedo={this.props.kedo}
                    />
                ) : null}
                <ToolbarButton
                    dense={this.props.size === 'sm'}
                    variant="outlined"
                    onClick={() =>
                        this.setState({ showForm: true, loading: true })
                    }
                    title="Bekijk wijzigingen"
                >
                    <FontAwesomeIcon icon={faHistory} />
                </ToolbarButton>
            </>
        )
    }
}

export default ContentDossierHistory
